export const SplitTestStatus = {
    ACTIVE: 'active',
    INACTIVE: 'inactive',
};
export const SplitTestState = {
    ACTIVE: 'Active',
    INACTIVE: 'Inactive',
    SCHEDULED: 'Scheduled',
    RUNNING: 'Running',
    LIVE: 'Live',
    FINISHED: 'Finished',
};
//# sourceMappingURL=types.js.map